import React, { useEffect, useState } from "react";
import "../css/landing.css";
import Round16 from "./round16";
import QuarterFinals from "./quarterFinals";
import SemiFinals from "./semiFinals";
import Final from "./final";
import axios from "axios";
import DiamondShape from "../widgets/diamondShape";
import R16Submission from "../functions/R16_Submission";
import QuarterFinals_Submission from "../functions/QuarterFinals_Submission";
import SemiFinals_Submission from "../functions/SemiFinals_Submission";
import Final_Submission from "../functions/Final_Submission";

export default function Landing() {
  const [match, setMatch] = useState([]);
  useEffect(() => {
    axios
      .get("https://bkcountdown.com/nodeapp/getCurrentMatch")
      .then((res) => {
        console.log(res);
        setMatch(res.data[0].match);
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  if (match == "QuarterFinals") {
    var submission = QuarterFinals_Submission;
  } else if (match == "SemiFinals") {
    var submission = SemiFinals_Submission;
  } else if (match == "Final") {
    var submission = Final_Submission;
  } else {
    var submission = R16Submission;
  }

  return (
    <div className="landing">
      <div className="container">
        <img src="./assets/fifa2022.png" alt="fifa2022" className="fifa2022" />{" "}
        <div class="countdownTitle web">
          <DiamondShape height="10" width="10" />
          <DiamondShape height="15" width="15" />
          ทายผลการแข่งขันฟุตบอลโลก 2022
          <DiamondShape height="15" width="15" />
          <DiamondShape height="10" width="10" />
        </div>
        <div class="countdownTitle mobile">
          <DiamondShape height="10" width="10" />
          <DiamondShape height="15" width="15" />
          การทำนายผลทีม
          <DiamondShape height="15" width="15" />
          <DiamondShape height="10" width="10" />
        </div>
        {match == "R16" ? <Round16 /> : ""}
        {match == "QuarterFinals" ? <QuarterFinals /> : ""}
        {match == "SemiFinals" ? <SemiFinals /> : ""}
        {match == "Final" ? <Final /> : ""}
        <p className="emailText">
          กรอกอีเมลที่ถูกต้องเพื่อรับการสรุปคำตอบของคุณ
        </p>
        <input
          className="usernameInput"
          id="emailInput"
          type="email"
          placeholder="กรอกอีเมลของคุณ"
        />
        <div className="usernameContainer">
          <p>หากคุณเป็นสมาชิกอยู่แล้ว</p>
          <div className="usernameSubContainer">
            {" "}
            <input
              className="usernameInput"
              id="usernameInput"
              type="text"
              placeholder="กรอกยูสเซอร์เนมของคุณ"
            />
            <div className="container submitBtnWrapper">
              <div
                className="submitBtnContainer"
                onClick={submission}
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
              >
                <img src="./assets/button-01.svg" alt="" />
                <p>ยืนยันการทายผล</p>
              </div>
            </div>{" "}
          </div>

          <p>หากยังไม่ได้เป็นสมาชิก!</p>
          <div className="usernameSubContainer">
            <div className="">
              <input
                className="phone_number"
                id="phone_number"
                type="number"
                placeholder="ป้อนหมายเลขโทรศัพท์ของคุณ"
              />
            </div>
            <div className="">
              {" "}
              <button
                className="registerNowBtn"
                onClick={submission}
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
              >
                ยืนยันและสมัครเลย
              </button>
            </div>
          </div>
        </div>
        {/* Modal */}
        <div
          class="modal fade"
          id="exampleModal"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body" id="modal_body"></div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  ปิด
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
